module.exports = __webpack_public_path__ + "media/country_flags/us-464559c4.png";